import { defineComponent } from 'vue';
import EvCheckbox from "@/components/EvCheckbox.vue";
import EvRadio from "@/components/EvRadio.vue";
import EvaluationSection from "@/components/EvaluationSection.vue";
import EvResult from "@/components/EvResult.vue";
import EventBus from '@/composables/EventBus'

interface Selected  {
  [key:string]:any
}
interface Results {
  'min': number,
  'max': number,
  'id': string
}


export default defineComponent({
  name: 'App',
  components: {
    EvCheckbox,
    EvaluationSection,
    EvRadio,
    EvResult
  },
  data() {
    return {
      checkbox: 0,
      totalRadio: 0,
      radio:{} as { [key: string]: any },
      radioTitles: [],
      results: [] as Array<Results>,
      specialCheckBox: 0,
      specialRadios: {} as { [key: string]: any },
      selected: {} as { [key: string]: any },
      list: [],
      resultTitle: "",
      resultContent: "",
      showWarning: false,
      showNoSelected: false,
      showResult: false,
      errors: false,
      errorIds: [] as string[],
      errorContainer: [] as boolean[],
      showError: false,
      customTitle: '',
      customContent: '',
      customParagraphs: [] as string[],
      addResultsToPdf: true,
      addDescriptionsToPdf: false
    }
  },
  props: {
    threshold: {
      type: String,
      default: "0"
    },
    warningText: String,
    logoPath: String,
    fileName: String,
    errorText: String,
    visiblePoints: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    totalCount():number {
      return this.checkbox + this.totalRadio;
    }
  },
  created(){

    const vm  = this;
    EventBus.on('addErrorId', function(id:any) {
      vm.errorIds.push(id);
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.removeAdditionalTextStyles()
    })
  },
  methods: {
    removeAdditionalTextStyles() {
      const containers = document.querySelectorAll('.evaluation-portlet')
      if (containers.length > 0) {
        containers.forEach(container => {
          if (container instanceof HTMLElement) this.removeAllAttributes(container, 'style')
        })
      }

    },
    removeAllAttributes(container:HTMLElement, attr:any):void {
      const attributes = container.querySelectorAll('['+attr+']')
      if (attributes.length > 0) {
        attributes.forEach(attr => {
          if (attr instanceof HTMLElement && (attr.tagName === 'P' || attr.tagName === 'SPAN')) {
              attr.removeAttribute('style')
          }
        })
      }
    },
    updateState(value:number,checked:boolean, name:string, title:string, type:string, specialRule:boolean ) {
      if (type === 'checkbox') {
        if (checked) {
          this.checkbox += value;
          if (specialRule) {
            this.specialCheckBox++;
          }
          this.selected[title] = title;
        } else {
          this.checkbox -= value;
          delete this.selected[title]
        }
      } else {
        this.radio[name] = value;
        this.selected[name] = title;
        this.specialRadios[name] = specialRule;
        this.totalRadio = this.sumRadios(this.radio);
      }
    },
    addResults(obj:Results) {
      this.results.push({'min':obj.min,'max':obj.max,'id':obj.id })
    },
    sumRadios( obj:any ) {
      let sum = 0;
      for( const el in obj ) {
        if( Object.prototype.hasOwnProperty.call(obj,el) ) {
          sum += parseFloat( obj[el] );
        }
      }
      return sum;
    },
    sumSpecialRadios( obj:Selected ) {
      let sum = 0;
      for( const el in obj ) {
        if( Object.prototype.hasOwnProperty.call(obj,el) ) {
          if ( obj[el] == true) {
            sum += 1;
          }
        }
      }
      return sum;

    },
    showResults() {
      this.showError = false;
      const total = this.checkbox + this.totalRadio;
      const obj = this.results;


      EventBus.emit('show-result', this.checkResultId(total,obj));
      this.showError = this.validate(this.errorIds);

      if (!this.showError) {
        this.showWarning = this.checkThreshold();
        this.list = [];
        this.addToFullList(this.selected, this.list);

        if (this.list.length > 0) {
          this.showResult = true;
        }  else {
          this.showNoSelected = true;
        }

      } else {
        this.showResult = false;
      }
    },
    checkResultId(total:number,obj:Array<Results>) {
      for ( const el in obj ) {
        if (  Object.prototype.hasOwnProperty.call(obj,el)) {
          if ( total >= obj[el].min && total <= obj[el].max ) {
            return obj[el].id
          }
        }
      }
    },
    addToFullList(obj:any, target:string[]) {
      for ( const el in obj ) {
        if (  Object.prototype.hasOwnProperty.call(obj,el)) {
          target.push(obj[el]);
        }
      }
    },
    checkThreshold() {
      const radioSpecial = this.sumSpecialRadios(this.specialRadios);
      const totalSpecial = this.specialCheckBox + radioSpecial;

      const target = Number(this.threshold)
      if ( totalSpecial >= target ) return true;
      return false
    },
    validate(id:string[]) {
      this.errorContainer = [];
      this.checkForErrors(id);
      let allStates = false;
      if (this.errorContainer.indexOf(false) !== -1) {
        allStates = true;
      }

      return allStates;
    },
    checkForErrors(ids:any) {
      const d = document;
      let state = false;

      for (const id of ids) {
        const validators = d.querySelectorAll('#'+id);
        if (validators.length > 0) {
          for (const validator of validators) {
            const errors = [];
            const inputs = validator.querySelectorAll('input');
            for (const input of inputs) {
              if (input.checked) {
                errors.push('true')
              } else {
                errors.push('false');
              }
            }
            if (errors.includes('true')) {
              state = true;
            } else {
              state = false;
            }

          }

        }

        this.errorContainer.push(state);
      }
    },
    addParagraph() {
      this.customParagraphs = this.customContent.split(/\r\n|\r|\n/g);
    }
  }
});
